'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var myMessage = arguments[1];
  var avatar = arguments[2];
  var compact = arguments[3];
  var iconMenu = arguments[4];
  var overrideStyle = arguments[5];

  var style = _styles2.default.message;

  if (myMessage) {
    style = (0, _combineStyles2.default)((0, _combineStyles2.default)(_styles2.default.message, _styles2.default.myMessage), { backgroundColor: color, borderRightColor: color });
  }

  if (avatar) {
    style = (0, _combineStyles2.default)(style, _styles2.default.avatar);
  }

  if (myMessage && avatar) {
    style = (0, _combineStyles2.default)(style, _styles2.default.myAvatar);
  }

  if (compact) {
    style = (0, _combineStyles2.default)(style, _styles2.default.compact);
  }

  if (compact && iconMenu) {
    style = (0, _combineStyles2.default)(style, { padding: '13px 48px 13px 13px' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var bar = function bar() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var myMessage = arguments[1];
  var played = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var style = (0, _combineStyles2.default)(_styles2.default.bar, { backgroundColor: color, width: played * 100 + '%' });

  if (myMessage) {
    style = (0, _combineStyles2.default)(style, { backgroundColor: _colors2.default.white });
  }

  return style;
};

exports.default = {
  root: root,
  bar: bar
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/audio-message/get-styles.js
// module id = 814
// module chunks = 0